import { __awaiter } from '../../../_virtual/_tslib.js';
import { config, send, script, decode } from '@onflow/fcl';
import { MagicWalletConnectorBase } from '../../MagicWalletConnectorBase.js';
import { logger } from '../../utils/logger/logger.js';
import { FlowMagicClient } from './FlowMagicClient.js';
import { PrepareMessage } from './PrepareMessage.js';

class MagicFlowWalletConnector extends MagicWalletConnectorBase {
    constructor(props) {
        super(props);
        this.connectedChain = 'FLOW';
        this.supportedChains = ['FLOW'];
        this.magicClient = new FlowMagicClient({
            apiKey: this.providerProps.apiKey,
            network: props.flowNetwork,
        });
        this.appName = props.appName;
        this.flow = {
            authorization: this.magicClient.getClient().flow
                .authorization,
        };
    }
    filter() {
        const result = super.filter() && this.chain === 'FLOW';
        if (!result)
            logger.warn(`MagicFlowWalletConnector: Magic is configured for a different chain: ${this.chain}. This wallet connector will be disabled.`);
        return result;
    }
    setupConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            yield config()
                .put('accessNode.api', this.magicClient.rpcUrl)
                .put('flow.network', this.magicClient.network);
        });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setupConfig();
            const address = yield this.fetchPublicAddress();
            if (address) {
                const code = `
      pub fun main(): UFix64 {
        let account = getAccount(${address});
        return account.balance;
      }
      `;
                try {
                    return yield send([script(code)]).then(decode);
                }
                catch (error) {
                    logger.error(error);
                    return undefined;
                }
            }
            else {
                return undefined;
            }
        });
    }
    getNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.magicClient.network;
        });
    }
    proveOwnership(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const signedMessage = yield this.signMessage(messageToSign);
                if (!signedMessage) {
                    return undefined;
                }
                const data = {
                    appName: this.appName,
                    signedMessage: JSON.parse(signedMessage),
                };
                return JSON.stringify(data);
            }
            catch (error) {
                logger.error(error);
                return undefined;
            }
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = PrepareMessage.userMessage(messageToSign);
            const result = yield this.walletUiUtils.signMessage({
                handler: () => __awaiter(this, void 0, void 0, function* () {
                    const { signingFunction } = yield this.magicClient
                        .getClient()
                        .flow.authorization();
                    const signedMessage = yield signingFunction({ message });
                    const compositeSignature = [
                        Object.assign({ f_type: 'CompositeSignature', f_vsn: '1.0.0' }, signedMessage),
                    ];
                    return JSON.stringify(compositeSignature);
                }),
                message: messageToSign,
            });
            return result;
        });
    }
}

export { MagicFlowWalletConnector };
